let prefix = 'spp';

export function setMetricPrefix(p) {
  prefix = p;
}

export function pageView(labels) {
  return { name: `${prefix}_page_view_total`, labels, value: 1 };
}

export function pageError(labels) {
  return { name: `${prefix}_page_error_total`, labels, value: 1 };
}

export function flowStart(labels) {
  return {
    name: `${prefix}_flow_start_total`,
    labels: { ...labels, status: 'initial' },
    value: 1,
  };
}

export function flowDuration(value, labels) {
  return { name: `${prefix}_flow_duration`, value, labels };
}

export function firstScreenDuration(value, labels) {
  return { name: `${prefix}_first_screen_duration`, value, labels };
}

export function apiErrorTotal(labels) {
  return { name: `${prefix}_api_error_total`, labels, value: 1 };
}

export function apiDuration(value, labels) {
  return { name: `${prefix}_api_duration`, value, labels };
}
